<template>
  <div class="paragraph">
    <h3>{{ $t('about.heading') }}</h3>
    <p class="text-justify">
      {{ $t('about.paragraph', {years: yearsOfExperience}) }}
    </p>
  </div>
</template>

<script>
export default {
    name: 'Description',
    data() {
    return {
      baseYear: 2021,
      currentYear: new Date().getFullYear(),
      yearsOfExperience: 0,
    };
  },
  created() {
    this.yearsOfExperience = this.currentYear - this.baseYear;
  }
}
</script>

<style scoped lang="scss">
    @import '@/styles/constants.scss';

    .paragraph {
        color: map-get($colors, primary);
        .begin {
            color: map-get($colors, secondary);
        }
    }
    .text-justify {
        text-align: justify;
    }
</style>
